import axios from 'axios'
import qs from 'qs'

import httpInterceptors from './httpInterceptors'
import cookie from 'vue-cookie'

axios.interceptors.request.use(httpInterceptors.config, httpInterceptors.err)
axios.interceptors.response.use(httpInterceptors.response, httpInterceptors.error)

let dataUrl = window.dataUrl
// 公共部分
export const publicService = {
  login: function () {
    var url = dataUrl.Account.login

    var para = {
      email: 'zhoujiantao@gridsum.com',
      password: 'share@123'
    }

    return axios({
      method: 'post',
      url: url,
      params: para
    })
  },
  historyLogin (para) {
    var url = dataUrl.Account.login

    // var para = {
    //   email: 'zhoujiantao@gridsum.com',
    //   password: 'share@123'
    // }
    return axios({
      method: 'post',
      url: url,
      params: para
    })
  },
  logout: function () {
    var url = dataUrl.Account.logout
    return axios({
      method: 'post',
      url: url
    })
  },
  getHistoryData: function (method, url, data) {
    return axios({
      method: method,
      url: url,
      data: data
    })
  }
}

export const seedTagsService = {
  seedColumnTags: function () {
    var url = dataUrl.SeedTags.seedColumnTags
    return axios({
      method: 'get',
      url: url
    })
  },
  seedProperties () {
    return axios({
      method: 'get',
      url: dataUrl.SeedTags.seedProperties
    })
  }
}
// 用户
export const accountService = {

  getUserInfo: function () {
    var url = dataUrl.Account.getUserInfo
    return axios({
      method: 'get',
      url: url
    })
  },
  loadAllAccount: function (para) {
    var url = dataUrl.Account.getAllAccount
    return axios({
      method: 'get',
      url: url
    })
  },
  deleteAccount: function (para) {
    var url = dataUrl.Account.deleteAccount
    return axios({
      method: 'delete',
      url: url,
      params: para
    })
  },
  editAccount: function (para) {
    var url = dataUrl.Account.editAccount.replace('{id}', para.Id).replace('{roleId}', para.RoleId)
    return axios({
      method: 'put',
      url: url
    })
  },
  addAccount: function (para) {
    var url = dataUrl.Account.addAccount.replace('{roleId}', para.RoleId)
    return axios({
      method: 'post',
      url: url,
      data: para
    })
  },
  logout: function () {
    var url = dataUrl.Account.logout
    return axios({
      method: 'post',
      url: url
    })
  }
}
// 角色
export const roleService = {

  loadAllRoles: function () {
    var url = dataUrl.RoleV2.allRoles
    return axios({
      method: 'get',
      url: url
    })
  },
  addRole: function (para) {
    var url = dataUrl.RoleV2.addRole
    return axios({
      method: 'post',
      url: url,
      data: para
    })
  },
  delRole: function (para) {
    var url = dataUrl.RoleV2.delRole.replace('{id}', para.Id)
    return axios({
      method: 'delete',
      url: url
    })
  },
  editRole: function (para) {
    var url = dataUrl.RoleV2.delRole.replace('{id}', para.Id)
    return axios({
      method: 'put',
      url: url,
      data: para
    })
  },
  getRole: function (para) {
    var url = dataUrl.RoleV2.delRole.replace('{id}', para.Id)
    return axios({
      method: 'get',
      url: url
    })
  }
}
// 配置
export const configService = {
  getDomain: function () {
    var url = dataUrl.Config.domain
    return axios({
      method: 'get',
      url: url
    })
  },
  getProperty: function () {
    var url = dataUrl.Config.property
    return axios({
      method: 'get',
      url: url
    })
  }
}

export const historyColumnService = {
  groupColumns: function () {
    var url = dataUrl.HistoryColumn.allGroupColumns
    return axios({
      method: 'get',
      url: url
    })
  },
  openState (param) {
    return axios({
      method: 'put',
      url: dataUrl.HistoryColumn.openState,
      data: param
    })
  },
  openColumns (params) {
    return axios({
      method: 'get',
      url: dataUrl.HistoryColumn.openColumns,
      params: params
    })
  }
}

export const tagService = {
  loadPersonTag: function (para) {
    var url = dataUrl.DataManage.dataListAll
    return axios({
      method: 'get',
      url: url,
      params: para
    })
  }

}
// 数据管理
export const dataManageService = {
  statusCount: function (para) {
    var url = dataUrl.DataManage.statusCount
    return axios({
      method: 'get',
      url: url,
      params: para
    })
  },
  loadListDataAll: function (para) {
    var url = dataUrl.DataManage.dataListAll
    return axios({
      method: 'get',
      url: url,
      params: para
    })
  },
  loadListDataUnpush: function (para) {
    var url = dataUrl.DataManage.dataListUnpush
    return axios({
      method: 'get',
      url: url,
      params: para
    })
  },
  loadListDataPush: function (para) {
    var url = dataUrl.DataManage.dataListPush
    return axios({
      method: 'get',
      url: url,
      params: para,
      paramsSerializer: function (params) {
        return qs.stringify(params, {arrayFormat: 'repeat'})
      }
    })
  },
  loadListDataDel: function (para) {
    var url = dataUrl.DataManage.dataListDel
    return axios({
      method: 'get',
      url: url,
      params: para
    })
  },
  addData: function (para) {
    var url = dataUrl.DataManage.addData
    return axios({
      method: 'post',
      url: url,
      data: para
    })
  },
  getData: function (id) {
    var url = dataUrl.DataManage.getData.replace('{id}', id)
    return axios({
      method: 'get',
      url: url
    })
  },
  editData: function (para) {
    var url = dataUrl.DataManage.editData.replace('{id}', para.Id)
    return axios({
      method: 'put',
      url: url,
      data: para
    })
  },
  delData: function (para) {
    var url = dataUrl.DataManage.delData
    return axios({
      method: 'put',
      url: url,
      data: para
    })
  },
  recoverData: function (para) {
    var url = dataUrl.DataManage.recoverData
    return axios({
      method: 'post',
      url: url,
      data: para
    })
  },
  pushData: function (para) {
    var url = dataUrl.DataManage.pushData
    return axios({
      method: 'put',
      url: url,
      data: para
    })
  },
  getSummary: function (para) {
    var url = dataUrl.DataManage.summary.replace('{id}', para.id)
    return axios({
      method: 'GET',
      url: url
    })
  },
  checkTitleRepeat: function (title) {
    var url = dataUrl.DataManage.titleCheck.replace('{title}', title)
    return axios({
      method: 'POST',
      url: url
    })
  },
  queryFinger: function (para) {
    var url = dataUrl.DataManage.queryFinger
    return axios({
      method: 'POST',
      data: para,
      url: url
    })
  },
  bulkPush: function (para) {
    var url = dataUrl.DataManage.bulkPush
    return axios({
      method: 'PUT',
      data: para,
      url: url
    })
  }

}
// 话题管理
export const topicManageService = {
  loadTopicList: function (para) {
    var url = dataUrl.TopicManage.topicList
    return axios({
      method: 'get',
      url: url,
      data: para
    })
  },
  addTopic: function (para) {
    var url = dataUrl.TopicManage.addTopic
    return axios({
      method: 'post',
      url: url,
      data: para
    })
  },
  delTopic: function (id) {
    var url = dataUrl.TopicManage.delTopic.replace('{id}', id)
    return axios({
      method: 'delete',
      url: url
    })
  },
  delTopics: function (para) {
    var url = dataUrl.TopicManage.delTopics
    return axios({
      method: 'delete',
      url: url,
      data: para
    })
  },
  getTopic: function (id) {
    var url = dataUrl.TopicManage.getTopic.replace('{id}', id)
    return axios({
      method: 'get',
      url: url
    })
  },
  editTopic: function (para) {
    var url = dataUrl.TopicManage.editTopic.replace('{id}', para.Id)
    return axios({
      method: 'put',
      url: url,
      data: para
    })
  },
  topicData: function (para) {
    var url = dataUrl.TopicManage.topicData.replace('{id}', para.Id)
    return axios({
      method: 'get',
      url: url,
      params: para
    })
  },
  delTopicData: function (para) {
    var url = dataUrl.TopicManage.delTopicData.replace('{id}', para.id)
    return axios({
      method: 'post',
      url: url,
      data: para.documentIds
    })
  },
  authTopic: function (para) {
    var url = dataUrl.TopicManage.authTopic.replace('{id}', para.Id)
    return axios({
      method: 'put',
      url: url,
      data: para.accountIds
    })
  },
  loadHistoryData: function (para) {
    var url = dataUrl.TopicManage.historyList
    return axios({
      method: 'post',
      url: url,
      params: para
    })
  },
  loadRegisterUser: function (para) {
    var url = dataUrl.TopicManage.registerUser
    return axios({
      method: 'post',
      url: url,
      params: para
    })
  },
  addHistoryColumn: function (url, data) {
    return axios({
      method: 'post',
      url: url,
      data: data
    })
  },

  updateColumn: function (url, data) {
    return axios({
      method: 'put',
      url: url,
      data: data
    })
  },

  loadManageHistoryData: function (para) {
    var url = dataUrl.TopicManage.allCloumns
    return axios({
      method: 'get',
      url: url
    })
  },

  delColumn: function (url) {
    return axios({
      method: 'delete',
      url: url
    })
  },

  getColumnById: function (url) {
    return axios({
      method: 'get',
      url: url
    })
  },
  loadHistoryDocuments: function (param) {
    let url = dataUrl.TopicManage.documents.replace('{columnId}', param.id)
    return axios({
      method: 'get',
      url: url,
      params: param
    })
  },
  deleteHistoryDocuments: function (param, data) {
    let url = dataUrl.TopicManage.deleteDocuments
    return axios({
      method: 'post',
      url: url,
      params: param,
      data: data
    })
  },
  deleteImage: function (url) {
    return axios({
      method: 'delete',
      url: url
    })
  }
}

export const tagManageService = {
  loadTags: function (url, param) {
    return axios({
      method: 'get',
      url: url,
      params: param
    })
  },
  deleteTag: function (url) {
    return axios({
      method: 'delete',
      url: url
    })
  },
  editTag: function (url, data) {
    return axios({
      method: 'put',
      url: url,
      data: data
    })
  },
  addTag: function (url, data) {
    return axios({
      method: 'post',
      url: url,
      data: data
    })
  },
  topTag: function (url, data) {
    return axios({
      method: 'post',
      url: url,
      data: data
    })
  }
}
// 历史库区域库服务

// 领域库
export const domainService = {
  getNavMenus () {
    return axios({
      method: 'get',
      url: dataUrl.History.konwledgeMenus
    })
  },
  searchData (pramas) {
    return axios({
      method: 'get',
      url: dataUrl.History.searchDomainReult,
      params: pramas
    })
  }
}

let createUrlParams = (ids) => {
  let ticket = null
  if (cookie.get('comeFrom') === 'oldHome') {
    ticket = cookie.get('ticket')
  } else {
    ticket = cookie.get('cird-ticket')
  }
  if (ticket) {
    ticket = ticket.replace(/"/g, '')
  }
  let url = ''
  let idLen = ids.length
  for (let i = 0; i < idLen - 1; i++) {
    url += 'ids=' + ids[i] + '&'
  }
  url += 'ids=' + ids[idLen - 1]

  return '&ticket=' + ticket + '&' + url
}

export const knowledgeBaseService = {
  download (ids) {
    let url = dataUrl.KnowledgeBase.downloadDoc + '?' + createUrlParams(ids)
    window.open(url)
  },
  downloadExcel (ids) {
    let url = dataUrl.KnowledgeBase.downloadExcel + '?format=xlsx&' + createUrlParams(ids)
    window.open(url)
  }
}

export const historyAreaService = {
  loadEventData: function (url) {
    return axios({
      method: 'post',
      url: url
    })
  }
}

export const historyEventService = {
  loadCountByYear: function () {
    var url = dataUrl.History.countByYear
    return axios({
      method: 'get',
      url: url
    })
  },
  loadCountByType: function () {
    var url = dataUrl.History.countByType
    return axios({
      method: 'get',
      url: url
    })
  },
  loadColums: function (url, param) {
    if (param) {
      param.orderByDate = 1
    }
    return axios({
      method: 'get',
      url: url,
      params: param
    })
  },
  loadRecommend (url, param) {
    return axios({
      method: 'get',
      url: url,
      params: param
    })
  },
  loadCodes: function (url, param) {
    return axios({
      method: 'get',
      url: url,
      params: param
    })
  },
  loadGroupByYear: function (param, url) {
    return axios({
      method: 'get',
      url: url
    })
  }
}

export const FileManageV2 = {
  download (id) {
    var url = dataUrl.FileManageV2.download.replace('{fileStoreId}', id)
    window.open(url)
  }
}

// 会员管理接口服务
export const userService = {
  // 检查用户名是否已被注册
  checkUser (params) {
    console.log(dataUrl, dataUrl.User)
    return axios({
      methods: 'get',
      url: dataUrl.User.userCheck,
      params: params
    })
  },

  registerCode (params) {
    return axios({
      method: 'get',
      url: dataUrl.User.registerCode,
      params: params
    })
  },

  // 注册
  register (params, queryParam) {
    return axios({
      method: 'post',
      url: dataUrl.User.register,
      data: params,
      params: queryParam
    })
  },

  // 登录
  userLogin (params) {
    return axios({
      method: 'post',
      url: dataUrl.User.userLogin,
      params: params
    })
  },

  // 登出
  userLogout () {
    return axios({
      method: 'post',
      url: dataUrl.User.userLogout
    })
  },

  // 会员管理列表
  userList () {
    return axios({
      method: 'get',
      url: dataUrl.User.userList
    })
  },
  // 修改密码-原密码校验/新密码和原密码重复校验
  pwdCheck (params) {
    return axios({
      method: 'get',
      url: dataUrl.User.pwdCheck,
      params: params
    })
  },

  // 修改密码-新密码
  pwdChange (params) {
    return axios({
      method: 'post',
      url: dataUrl.User.pwdChange,
      params: params
    })
  },

  // 找回密码-新密码
  pwdReset (params) {
    return axios({
      method: 'post',
      url: dataUrl.User.pwdReset,
      params: params
    })
  },

  // 找回密码-发送验证码
  codeSend (params) {
    return axios({
      method: 'get',
      url: dataUrl.User.codeSend,
      params: params
    })
  },

  // 找回密码-校验验证码
  codeCheck (params) {
    return axios({
      method: 'get',
      url: dataUrl.User.codeCheck,
      params: params
    })
  },

  // 找回密码-验证邮箱已注册
  emailCheck (params) {
    return axios({
      method: 'get',
      url: dataUrl.User.emailCheck,
      params: params
    })
  },
  // 用户信息
  getUserInfo () {
    return axios({
      method: 'get',
      url: dataUrl.User.userInfo
    })
  },
  // 更新用户
  updateUser (params) {
    return axios({
      method: 'post',
      url: dataUrl.User.updateUser,
      data: params
    })
  }
}

// 编年页面服务
export const annalisticService = {
  getYearCount () {
    return axios({
      method: 'get',
      url: dataUrl.Annalistic.yearCount
    })
  },

  getMonthCount (params) {
    return axios({
      method: 'get',
      url: dataUrl.Annalistic.monthCount,
      params: params
    })
  },

  getDayCount (params) {
    return axios({
      method: 'get',
      url: dataUrl.Annalistic.dayCount,
      params: params
    })
  },

  getList (params) {
    return axios({
      method: 'get',
      url: dataUrl.Annalistic.listDoc,
      params: params
    })
  }
}


// WEBPACK FOOTER //
// ./src/service/httpService.js